module.exports = __webpack_public_path__ + "static/media/MixedCookies.0d91575f.jpeg";